import React from 'react';
import { withTranslation } from 'react-i18next';

import { getQueryParamByName } from '../Utils/helpers';

// The two promo cards that can appear next to the main card (desktop only).
const CGCONNECT = {
  name: 'CGconnect',
  weight: 2,
  logo: '/images/cgconnect-logo.png',
  image: '/images/cgconnect-promo.png',
  title: 'The Home of the Design & Visualization Community.',
  subtitle: 'Showcase your work. Learn from experts. Grow your career.',
  url: window.CG_CONNECT,
  trackingId: 'gtm-promo-cgconnect',
};

const CHAOS_ACADEMY = {
  name: 'Chaos Academy',
  weight: 1,
  logo: '/images/academy-logo.png',
  image: '/images/academy-promo.png',
  title: 'Learn the workflows that bring your ideas to life.',
  subtitle: 'Master Chaos products through practical, self-paced learning.',
  url: window.CHAOS_ACADEMY,
  trackingId: 'gtm-promo-chaos-academy',
};

const PROMOS = [CGCONNECT, CHAOS_ACADEMY];

// The host a URL points at, or '' when it isn't a valid absolute URL.
const hostOf = (url) => {
  try {
    return new URL(url).host;
  } catch (err) {
    return '';
  }
};

// Whether the sign-in came from a given product, by looking for its configured
// host anywhere in the return_to. A host appears literally even when it is
// nested and percent-encoded, which covers Chaos Academy: its sign-in goes
// through the Thought Industries SSO gateway, so the academy host sits inside
// the gateway's own return_to rather than at the top level.
const comesFrom = (returnTo, productUrl) => {
  const host = hostOf(productUrl);
  return host !== '' && returnTo.includes(host);
};

// Each promo enters the draw `weight` times, so CGconnect (2) is picked twice as often as Chaos Academy (1).
const weightedRandomPromo = () => {
  const draw = PROMOS.flatMap((promo) => Array(promo.weight).fill(promo));
  return draw[Math.floor(Math.random() * draw.length)];
};

// Which promo to show:
// - Signing in through one product cross-promotes the other.
// - Every other case shows a weighted random one (CGconnect twice as often as Chaos Academy).
const pickPromo = () => {
  const returnTo = getQueryParamByName('return_to') || '';

  if (comesFrom(returnTo, CGCONNECT.url)) return CHAOS_ACADEMY;
  if (comesFrom(returnTo, CHAOS_ACADEMY.url)) return CGCONNECT;

  return weightedRandomPromo();
};

// Picked once per page load, so the card stays the same while navigating between pages.
const selectedPromo = pickPromo();

const Promo = withTranslation()(({ t }) => (
  <aside className="promo-card">
    <img className="promo-card-logo" src={`${selectedPromo.logo}?v=1`} alt={selectedPromo.name} />
    <h2 className="promo-card-title">{t(selectedPromo.title)}</h2>
    <p className="promo-card-subtitle">{t(selectedPromo.subtitle)}</p>
    <a id={`${selectedPromo.trackingId}-image`} href={selectedPromo.url} target="_blank" rel="noreferrer">
      <img className="promo-card-image" src={`${selectedPromo.image}?v=1`} alt="" />
    </a>
    <a
      className="promo-card-button"
      id={selectedPromo.trackingId}
      href={selectedPromo.url}
      target="_blank"
      rel="noreferrer"
    >
      {t('Join now for free')}
    </a>
  </aside>
));

export default Promo;
